export default __webpack_public_path__ + "static/media/17_World_Tree_Village.8dc12455.png";